import React, { useEffect, useState } from 'react'
import './navbar.scss'
import Profile from "../../../assets/images/icons/profile-full.png";
import Trade from "../../../assets/images/icons/trade.png";
import History from "../../../assets/images/icons/history.png";

import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../../features';
import { closeMenu, isMenuOpened, openMenu } from '../../../store/AppSlice';
import { getInPayment } from '../../../store/TransactionSlice';
import { getAccessToken, getRefreshToken } from '../../../store/EncryptionSlice';

export const Navbar: React.FC = () => {

    const navigate                  = useNavigate();
    const location                  = useLocation();

    const [disabled, setDisabled]   = useState(false);
    const [currentLocation, setCurrentLocation]   = useState<string>('');

    const hasToken                  = useAppSelector(getAccessToken);
    const hasRt                     = useAppSelector(getRefreshToken);
    const menuOpened                = useAppSelector(isMenuOpened);
    const inPayment                 = useAppSelector(getInPayment);

    const dispatch = useAppDispatch();

    useEffect(() => {
        setDisabled(hasToken && hasRt ? false : true);

        if (inPayment) dispatch(closeMenu())
        if (!inPayment) dispatch(openMenu())

    }, [inPayment, hasToken, hasRt, dispatch]);

    useEffect( () => {
        setCurrentLocation(location.pathname);
    }, [currentLocation, setCurrentLocation, location])


    const handleNavClick = (target: string) => {
        
        setCurrentLocation("/"+target);
        const targetPath = '/' + target;
        //dispatch(cleanListTransactions());

        if (location.pathname === targetPath) return;
        if (!disabled || target === 'home') navigate(targetPath);
        
    };

    return (
        <>
            {menuOpened ? (
                <div className="menu">
                    <ul>
                        <li 
                        onClick={() => handleNavClick('history')} 
                        className={` ${disabled ? 'disabled' : ''} ${currentLocation === '/history' ? 'active' : null} `}>
                            <img src={History} alt="" />
                        </li>
                        <li 
                        onClick={() => handleNavClick('home')}
                        className={`${currentLocation === '/home' ? 'active' : null} `}>
                            <
                                img src={Trade} alt="" />
                        </li>
                        <li 
                        onClick={() => handleNavClick('profile')} 
                        className={` ${disabled ? 'disabled' : ''} ${currentLocation === '/profile' ? 'active' : null} `}>
                            <img src={Profile} alt="" />
                        </li>
                    </ul>
                </div>
            ) : <></>}
        </>
    )
}